// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"2471fbd2","977":"78fedf8a"}[chunkId] + ".chunk.js";
};